// Animating the image change with text using GSAP
// 1. Get the button element
// 2. Get the image and description wrapper elements
// 3. Add a click event listener to the button
// 4. On click, check the index of the currently visible image
// 5. Hide the current image and description wrapper
// 6. Show the next image and description wrapper

// including scrollTrigger for desktop
gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", function () {
  // creating gsap media object
  let mm = gsap.matchMedia();

  // creating a timeline for squence animation
  const timeline = gsap.timeline();

  // For mobile animation
  const button = document.querySelector(".button__container");
  const buttonElement = document.querySelector(".button__container button")
  const imageWrapper = document.querySelectorAll(
    ".image-with-description__wrapper"
  );
  const video = document.querySelector(".video__wrapper video");
  let currentElement = document.querySelector(
    ".image-with-description__wrapper"
  );
  let nextElement = currentElement.nextElementSibling;
  const totalElements = imageWrapper.length;

  button.addEventListener("click", function () {
    timeline.to(buttonElement,{
      backgroundColor: "rgb(70,10,49,0.8)",
      onStart: () => buttonElement.setAttribute("disabled", "disabled")
    })
    timeline.to(currentElement, {
      opacity: 0,
      display: "none",
      duration: 0.4,
      ease: "none",
    });

    timeline.to(".image-change-with-text", {
      xPercent: nextElement.dataset.horizontal,
      yPercent: nextElement.dataset.vertical,
      scale: nextElement.dataset.scale,
      ease: "none",
    });

    timeline.to(
      nextElement,
      {
        opacity: 1,
        display: "flex",
        duration: 0.4,
        ease: "none",
      },
      "-=0.2"
    );
    currentElement = nextElement;
    if (currentElement.dataset.index == totalElements) {
      nextElement = imageWrapper[0];
    } else {
      nextElement = nextElement.nextElementSibling;
    }
    timeline.to(buttonElement,{
      backgroundColor: "rgb(70,10,49,1)",
      onComplete: () => buttonElement.removeAttribute("disabled")
    })
  });

  // For desktop animation
  // -on scroll, the video should zoomed in and the image and description should change
  // -the animation should be continuous and should work in reverser too.

  mm.add("(min-width: 1440px)", () => {
    const timeline = gsap.timeline();
    ScrollTrigger.create({
      animation: timeline,
      trigger: ".image-change-with-text__container",
      start: "-5% top",
      end: "+=100%",
      scrub: true,
      onUpdate: (self) => {
        const progress = self.progress;
        const elementindex = Math.round(progress * totalElements);
        imageWrapper.forEach((wrapper, index) => {
          if (index === elementindex) {
            gsap.to(wrapper, {
              opacity: 1,
              display: "flex",
              duration: 0.1,
              ease: "none",
            });

            // Update video position and scale
            gsap.to(".image-change-with-text", {
              xPercent: wrapper.dataset.horizontal,
              yPercent: wrapper.dataset.vertical,
              scale: wrapper.dataset.scale,
              duration: 0.5,
              ease: "none",
            });
          } else if (
            index === totalElements - 1 &&
            elementindex > totalElements - 1
          ) {
            gsap.to(wrapper, {
              opacity: 1,
              display: "flex",
              duration: 0.5,
              ease: "none",
            });
          } else {
            gsap.to(wrapper, {
              opacity: 0,
              display: "none",
              duration: 0.1,
              ease: "none",
            });
          }
        });
      },
    });
  });
});
